import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import { DEFAULT_DESCRIPTION } from '../lib/siteMeta';
import Hero from '../components/home/Hero';
import Stats from '../components/home/Stats';
import WhyChooseUs from '../components/home/WhyChooseUs';
import Testimonials from '../components/home/Testimonials';
import PopularFormations from '../components/home/PopularFormations';
import CTA from '../components/home/CTA';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Formations santé Qualiopi — DPC, FIFPL, OPCO & CPF"
        description={DEFAULT_DESCRIPTION}
        canonicalPath="/"
      />
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <WhyChooseUs />
        <PopularFormations />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
